// extracted by mini-css-extract-plugin
module.exports = {"status":"DateBadge_status__AumU6","statusText":"DateBadge_statusText__fZZm4"};